import { Component } from '@angular/core';
import { SharedModule } from '../../shared/shared/shared.module';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { StorageService } from '../../core/services/storage.service';

@Component({
  selector: 'app-error-page',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './error-page.component.html',
  styleUrl: './error-page.component.css'
})
export class ErrorPageComponent {
constructor(
  private router: Router,
  private storageService: StorageService
) {}

refresh() {
  const accessToken = this.storageService.getAccessToken(); 
  const verificationStatus = this.storageService.getVerificationStatus();

  // 1️⃣ No token → Login
  if (!accessToken) {
    this.router.navigate(['/account/login']);
    return;
  }

  // 2️⃣ Approved + token → Dashboard
  if (verificationStatus === 'APPROVED') {
    this.router.navigate(['/partner/dashboard']);
    return;
  }

  // 3️⃣ Token present but not approved → Onboarding
  this.router.navigate(['/partner/onboarding']);
}
}